module.exports = __webpack_public_path__ + "img/e3d1fc8.png";